import { FEEDBACK_MESSAGES, PREFIX_PHONE_LIST, REGEX } from '../../config'
import { addErrorMsg } from './addErrorMsg'

export const LANGUAGES = {
  EN: 'en',
  DE: 'deu',
  FR: "fr"
}

export const getLanguage = () => {
  const $modalInEnglish = document.querySelector('.custom-budget--en')
  const $modalInDeu = document.querySelector('.custom-budget--de')
  const $modalInFr = document.querySelector('.custom-budget--fr')

  if ($modalInEnglish !== null) return LANGUAGES.EN
  if ($modalInDeu !== null) return LANGUAGES.DE
  if ($modalInFr !== null) return LANGUAGES.FR

}

export function validationPhoneWithPrefix({
  prefixSelected,
  phoneValue,
  explainMsgPhone
}) {
  const VALIDATIONS_NUMBERS = [
    {
      prefix: PREFIX_PHONE_LIST.SPAIN_PHONE,
      regex: REGEX.NATIONAL_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.GERMAN_PHONE,
      regex: REGEX.GERMAN_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.UK_PHONE,
      regex: REGEX.UK_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.FRENCH_PHONE,
      regex: REGEX.FRENCH_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.BELGIAN_PHONE,
      regex: REGEX.BELGIAN_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.DANISH_PHONE,
      regex: REGEX.DANISH_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.IRISH_PHONE,
      regex: REGEX.IRISH_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.NORWEGIAN_PHONE,
      regex: REGEX.NORWEGIAN_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.SWEDISH_PHONE,
      regex: REGEX.SWEDISH_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.DUTCH_PHONE,
      regex: REGEX.DUTCH_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.SWISS_PHONE,
      regex: REGEX.SWISS_PHONE
    },
    {
      prefix: PREFIX_PHONE_LIST.AUSTRIAN_PHONE,
      regex: REGEX.AUSTRIAN_PHONE
    }
  ]

  let thereAreErrors = true

  VALIDATIONS_NUMBERS.forEach(({ prefix, regex }) => {
    if (prefixSelected === prefix && regex.test(phoneValue)) {
      thereAreErrors = false
    }
  })

  if (
    prefixSelected !== PREFIX_PHONE_LIST.SPAIN_PHONE &&
    REGEX.JUST_NUMBERS.test(phoneValue)
  ) {
    thereAreErrors = false
  }

  if (thereAreErrors) {
    explainMsgPhone?.remove()
    addErrorMsg({
      field: 'telefono',
      msg: getLanguage() === LANGUAGES.EN
        ? FEEDBACK_MESSAGES.ERROR.PHONE_INVALID_EN
        : getLanguage() === LANGUAGES.DE
          ? FEEDBACK_MESSAGES.ERROR.PHONE_INVALID_DE
          : getLanguage() === LANGUAGES.FR
          ? FEEDBACK_MESSAGES.ERROR.PHONE_INVALID_FR
          : FEEDBACK_MESSAGES.ERROR.PHONE_INVALID
    });
  } else {
    const $phoneField = document.querySelector('.custom-budget__field--phone')
    const error = $phoneField.querySelector('.custom-budget__error')
    error?.remove()
  }
}
